
export const styles = {
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        marginBottom: -5,
    },
    fontSizeFiftin: {
        fontSize: 15
    },
    divider: {
        borderBottomWidth: 1,
        height: 5,
    },
    dwnldAssetMasterStyle: {
        marginTop: 2,
        marginBottom: 2,
        marginLeft: 13,
    },
    assetmasterCardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    assetmasterCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    },
    assetmasterCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    locContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
    },
    dwnldAssetMasterbttnStyle: {
        display: 'flex',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        alignItems: 'center', justifyContent: 'flex-start'
    },

    fileStyle: {
        display: { lg: "flex", md: "flex" },
        gap: "1rem",
    },
    fileInputStyle: {
        border: "1px solid lightgrey",
        borderRadius: "5px",
    },

};


export default styles;
